import {
    ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY,
    ADD_LICENCE_ERROR,
    ADD_LICENCE_PENDING,
    ADD_LICENCE_SELECT_COMPANY,
    ADD_LICENCE_SELECT_PRODUCT,
    ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS,
    ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS,
    ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS,
    ADD_LICENCE_SET_AVAILABLE_COMPANIES,
    ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS,
    ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT,
    ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS, ADD_LICENCE_SET_LICENCE_ELEMENTS,
    ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS,
    ADD_LICENCE_SUCCESS,
    CLEAR_NEWLY_ADDED_LICENCE
} from "../actions/types";
import {useSelector} from "react-redux";

const INITIAL_STATE = {
    selectedCompany: null,
    allExpiryActions: [],
    availableExpiryActions: [],
    availableSoftwareProducts: [],
    allSoftwareProductElements: [],
    availableSoftwareProductElements: [],
    availableCompanies: [],
    companyHasSoftwareProducts: [],
    companyPreviouslyAddedProducts: [],
    newLicence: null,
    licenceSavePending: false,
    addingLicenceForAlreadyAddedSwProductForCompany: false,
    selectedProduct: null,

    licenceElements: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case ADD_LICENCE_PENDING:
            return {
                ...state,
                licenceSavePending: true,
                newLicence: null
            };
        case ADD_LICENCE_SUCCESS:
            return {
                ...state,
                licenceSavePending: false,
                newLicence: action.payload
            };
        case ADD_LICENCE_ERROR:
            return {
                ...state,
                licenceSavePending: false,
                newLicence: null
            };
        case CLEAR_NEWLY_ADDED_LICENCE: {
            return {
                ...state,
                newLicence: null
            }
        }

        case ADD_LICENCE_SELECT_COMPANY:
            return {
                ...state,
                selectedCompany: action.payload
            };

        case ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS:
            return {
                ...state,
                allExpiryActions: action.payload
            };

        case ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS:
            return {
                ...state,
                availableExpiryActions: action.payload
            };

        case ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS:
            return {
                ...state,
                availableSoftwareProducts: action.payload
            };

        case ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS:
            return {
                ...state,
                allSoftwareProductElements: action.payload
            };
        case ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS:
            return {
                ...state,
                availableSoftwareProductElements: action.payload
            };

        case ADD_LICENCE_SET_AVAILABLE_COMPANIES:
            return {
                ...state,
                availableCompanies: action.payload
            };

        case ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT:
            return {
                ...state,
                companyHasSoftwareProducts: action.payload
            };

        case ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS:
            return {
                ...state,
                companyPreviouslyAddedProducts: action.payload
            };
        case ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY:
            return {
                ...state,
                addingLicenceForAlreadyAddedSwProductForCompany: action.payload
            };
        case ADD_LICENCE_SELECT_PRODUCT:
            return {
                ...state,
                selectedProduct: action.payload
            };
        case ADD_LICENCE_SET_LICENCE_ELEMENTS:
            return {
                ...state,
                licenceElements: action.payload
            };

        default:
            return state;
    }
}

export const addLicenceSelector = () => state => state.addLicence;

export const useAddLicenceSelector = () => useSelector(addLicenceSelector());